var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show
    ? _c(
        "v-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "500px" },
              model: {
                value: _vm.show,
                callback: function ($$v) {
                  _vm.show = $$v
                },
                expression: "show",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    {
                      staticClass:
                        "secondary white--text d-flex align-center justify-space-between",
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "header-font",
                          staticStyle: { "font-size": "22px" },
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "mr-2",
                              staticStyle: { "font-size": "18px" },
                              attrs: { color: "white" },
                            },
                            [_vm._v("share")]
                          ),
                          _vm._v(
                            "\n          " + _vm._s(_vm.title) + "\n        "
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-subtitle",
                    {
                      staticClass:
                        "secondary py-2 white--text d-flex align-center justify-space-between",
                    },
                    [
                      _c("span", { staticClass: "subheader-font body-2" }, [
                        _vm._v(" " + _vm._s(_vm.subtitle)),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    { staticClass: "pb-2 mt-5" },
                    [
                      _c(
                        "v-container",
                        { staticClass: "py-0" },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "pa-0 ma-0",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "body-1 font-weight-bold primary--text mb-0",
                                    },
                                    [_vm._v("Link")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                {
                                  staticClass:
                                    "py-0 px-1 d-flex justify-space-between align-end",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c("v-text-field", {
                                    ref: "linkInputRef",
                                    staticClass: "mr-2 py-0 slim-input",
                                    attrs: {
                                      readonly: "",
                                      value: _vm.link,
                                      "hide-details": "",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "elevation-0",
                                      attrs: { color: "secondary", small: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.copyClipboard("link")
                                        },
                                      },
                                    },
                                    [
                                      _c("v-icon", { attrs: { small: "" } }, [
                                        _vm._v("content_copy"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                {
                                  staticClass: "pa-0 ma-0 mt-5",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "body-1 font-weight-bold primary--text mb-0",
                                    },
                                    [_vm._v("Embed")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                {
                                  staticClass:
                                    "py-0 px-1 d-flex justify-space-between align-end",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c("v-text-field", {
                                    ref: "embedInputRef",
                                    staticClass: "mr-2 py-0 slim-input",
                                    attrs: {
                                      readonly: "",
                                      value: _vm.embed,
                                      "hide-details": "",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "elevation-0",
                                      attrs: { color: "secondary", small: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.copyClipboard("embed")
                                        },
                                      },
                                    },
                                    [
                                      _c("v-icon", { attrs: { small: "" } }, [
                                        _vm._v("content_copy"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                {
                                  staticClass: "pa-0 ma-0 mt-5",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "body-1 font-weight-bold primary--text mb-0",
                                    },
                                    [_vm._v("IFrame")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                {
                                  staticClass:
                                    "py-0 px-1 d-flex justify-space-between align-end",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c("v-text-field", {
                                    ref: "iframeInputRef",
                                    staticClass: "mr-2 py-0 slim-input",
                                    attrs: {
                                      readonly: "",
                                      value: _vm.iframe,
                                      "hide-details": "",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "elevation-0",
                                      attrs: { color: "secondary", small: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.copyClipboard("iframe")
                                        },
                                      },
                                    },
                                    [
                                      _c("v-icon", { attrs: { small: "" } }, [
                                        _vm._v("content_copy"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.isMarca
                                ? _c(
                                    "v-row",
                                    { staticClass: "pa-0 ma-0" },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "pa-0 ma-0 mt-5",
                                          attrs: { cols: "12" },
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "body-1 font-weight-bold primary--text mb-0",
                                            },
                                            [_vm._v("IFrame AMP")]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass:
                                            "py-0 px-1 d-flex justify-space-between align-end",
                                          attrs: { cols: "12" },
                                        },
                                        [
                                          _c("v-text-field", {
                                            ref: "iframeAMPInputRef",
                                            staticClass: "mr-2 py-0 slim-input",
                                            attrs: {
                                              readonly: "",
                                              value: _vm.iframeAMP,
                                              "hide-details": "",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "elevation-0",
                                              attrs: {
                                                color: "secondary",
                                                small: "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.copyClipboard(
                                                    "iframeAMP"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { small: "" } },
                                                [_vm._v("content_copy")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "12 pt-3 px-0" } },
                                [
                                  _vm.textAlert
                                    ? _c(
                                        "v-alert",
                                        {
                                          attrs: {
                                            color:
                                              "success lighten-3 mb-0 body-2",
                                            dense: "",
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.textAlert) + " ")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    { staticClass: "pr-6 pb-4 d-flex justify-end" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "elevation-0 monospace-font px-4",
                          attrs: {
                            color: _vm.$vuetify.theme.dark
                              ? "white"
                              : "secondary",
                            rounded: "",
                            outlined: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onCancelClick()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("general.cancel")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass:
                            "elevation-0 monospace-font white--text px-4",
                          attrs: { rounded: "", color: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.onSaveClick()
                            },
                          },
                        },
                        [_vm._v("OK")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }